import { useFragment } from "@smart/itops-hooks-dom";
import { StatusOverlay } from "@smart/itops-sb-design-system-dom";

import { Login } from "./login";
import { Existing, Providers } from "../components";
import { authApi, useProvider } from "../hooks";

const RouteSelector = () => {
  const [fragment] = useFragment(["response", "email", "provider", "clear"]);
  const check = authApi.check({ body: undefined });
  const env = authApi.env({ body: undefined });
  const { provider, selectProvider } = useProvider(
    fragment.provider || check.result?.provider,
  );

  if (!check.result) return <StatusOverlay {...check} />;

  if (check.result.hasToken && !fragment.clear)
    return <Existing {...check.result} errorCode={fragment.response} />;

  if (!provider)
    return <Providers select={selectProvider} errorCode={fragment.response} />;

  return (
    <>
      <StatusOverlay {...env} />
      {env.result && (
        <Login
          env={env.result}
          provider={provider}
          fragment={fragment}
          clear={() => selectProvider(undefined)}
        />
      )}
    </>
  );
};

export { RouteSelector };
